// Voeg hier je eigen custom JavaScript toe. Let op: Gebruik geen jQuery, maar vanilla JavaScript.

// On document ready:
document.addEventListener('DOMContentLoaded', function () {
    // Add your custom JavaScript here.
    // NOTE: This script will be loaded on every page AND in the Gutenberg editor.
    console.log('Page loaded!');
});

window.addEventListener("scroll", function () {
  const scrollPos = window.scrollY;
  const body = document.body; // of document.querySelector("header") etc.

  if (scrollPos > 100) {
    body.classList.add("scrolled");
  } else {
    body.classList.remove("scrolled");
  }
});